import React, { useEffect, useState } from 'react'
import clsx from 'clsx'
import { ADMIN_ROUTES } from '../../../../../constants'
import useCheckPolicy from '../../../../../hooks/useCheckPolicy'

const InfographicNavigation = () => {
  const [activeTab, setActiveTab] = useState('reportRuns')
  const permissions = {
    reportRuns: useCheckPolicy('admin_view_info_reports'),
    templates: useCheckPolicy('admin_edit_info_templates'),
    blocks: useCheckPolicy('internalOnly')
  }

  const navItems = [
    {
      label: 'Infographic Runs',
      route: ADMIN_ROUTES.INFOGRAPHIC_REPORTS,
      key: 'reportRuns',
      visible: permissions.reportRuns
    },
    {
      label: 'Template Builder',
      route: ADMIN_ROUTES.INFOGRAPHIC_REPORTS_TEMPLATE,
      key: 'templates',
      visible: permissions.templates
    },
    {
      label: 'Block Builder',
      route: ADMIN_ROUTES.INFOGRAPHIC_REPORTS_BLOCK,
      key: 'blocks',
      visible: permissions.blocks
    }
  ]

  useEffect(() => {
    const path = window.location.pathname
    if (path.indexOf(ADMIN_ROUTES.INFOGRAPHIC_REPORTS_TEMPLATE) >= 0) {
      setActiveTab('templates')
    } else if (path.indexOf(ADMIN_ROUTES.INFOGRAPHIC_REPORTS_BLOCK) >= 0) {
      setActiveTab('blocks')
    } else {
      setActiveTab('reportRuns')
    }
  }, [])

  return (
    <div className='flex justify-start gap-5'>
      {navItems.filter(({ visible }) => !!visible)?.map((item) => (
        <a
          key={item.key}
          href={item.route}
          className={clsx('font-size-lg opal-link', {
            'opacity-100 font-bold': activeTab === item.key,
            'opacity-lowlighted font-light': activeTab !== item.key
          })}
        >
          {item.label}
        </a>
      ))}
    </div>
  )
}

export default InfographicNavigation
